import { render, staticRenderFns } from "./subjectList-add-or-update.vue?vue&type=template&id=2bbbdb92&scoped=true&"
import script from "./subjectList-add-or-update.vue?vue&type=script&lang=js&"
export * from "./subjectList-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./subjectList-add-or-update.vue?vue&type=style&index=0&id=2bbbdb92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbdb92",
  null
  
)

export default component.exports